import "core-js/modules/es.object.to-string.js";
import ItemMarketingBannerGraphql from '~/components/Molecules/ItemMarketingBannerGraphql.vue';
import MenuItemGraphql from '~/components/Atoms/MenuItemGraphql.vue';
import useMenu from '~/composables/useMenu';
export default {
  __name: 'MenuSidebarThirdLevelGraphql',
  props: {
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    topLevelCategory: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    marketingBanners: {
      type: Array,
      default: function _default() {}
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var _useMenu = useMenu(),
      getMenuItemLink = _useMenu.getMenuItemLink;

    /**
     * check if some sub items will be displayed (have valid links)
     */
    var hasItemsWithValidLink = computed(function () {
      var _props$items;
      return ((_props$items = props.items) === null || _props$items === void 0 ? void 0 : _props$items.length) > 0 && props.items.some(function (item) {
        return getMenuItemLink(item) != null;
      });
    });
    return {
      __sfc: true,
      getMenuItemLink: getMenuItemLink,
      props: props,
      hasItemsWithValidLink: hasItemsWithValidLink,
      ItemMarketingBannerGraphql: ItemMarketingBannerGraphql,
      MenuItemGraphql: MenuItemGraphql
    };
  }
};